// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import App from './App';
import MainComponent from '@/components/MainComponent';
// import router from './router';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<MainComponent/>',
  components: { MainComponent }
});



// WEBPACK FOOTER //
// ./src/main.js